import styled from 'styled-components';
import {
  fontFamilyPrimary,
  colorSecondaryLighten20,
  colorSecondary,
  colorPrimary,
  colorPrimaryLighten95,
  colorGrey400,
  mediaQueryMobileLargeMin,
} from 'styles';
import { Wrapper as SectionWrapper } from 'components/CurrencyExchangeTable/styles';
import { CommentsLink } from 'components/ExchangeDiscussion/styles';
import { Paragraph } from 'components/Typography';
import { TableFooter } from 'components/Table/styles';

export const Wrapper = styled(SectionWrapper)``;

export const Header = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Info = styled.div`
  display: inline-block;
  color: ${({ closed }) => (closed === '1' ? colorSecondary : colorPrimary)};
  background-color: ${({ closed }) =>
    closed === '1' ? colorSecondaryLighten20 : colorPrimaryLighten95};
  font-family: ${fontFamilyPrimary};
  font-size: 13px;
  font-weight: normal;
  line-height: 27px;
  height: 28px;
  border-radius: 14px;
  padding: 0 8px;
  margin-bottom: 10px;

  &:before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;
    display: inline-block;
    background-color: ${({ closed }) =>
      closed === '1' ? colorSecondary : colorPrimary};
  }
`;

export const Link = styled(CommentsLink)`
  margin-top: 0;
`;
export const StyledTableFooter = styled(TableFooter)`
  margin-top: 8px;
  display: flex;
  width: 100%;
  flex-direction: column-reverse;
  align-items: flex-start;
  margin-bottom: 32px;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0;
  }
`;

export const Source = styled(Paragraph)`
  color: ${colorGrey400};
  line-height: 16px;
  margin-bottom: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-bottom: 0;
  }
`;
